import { Icon } from '@wartek-id/icon-v2'

import IconBg from 'app/GNNPage/components/IconBg'

export const MITRA_CARDS = [
  {
    fullDescription:
      'Gernastastaka (Gerakan Nasional Pemberantasan Buta Matematika) adalah gerakan inisiatif masyarakat yang diinisiasi oleh para pegiat pendidikan yang peduli terhadap proses belajar matematika di sekolah dasar dan madrasah ibtidaiyah pada tanggal 10 November 2018. Gernastastaka fokus pada perbaikan proses belajar mengajar matematika di SD/MI. Gernastastaka mendesain dan melaksanakan pelatihan untuk pelatih dengan tujuan meningkatkan kemampuan guru agar mampu melaksanakan pembelajaran matematika menggunakan pendekatan bernalar, kontekstual, sederhana dan mendasar.',
    fullName: 'Gerakan Nasional Pemberantasan Buta Matematika',
    name: 'Gernastastaka',
    shortDescription:
      'Gerakan inisiatif masyarakat yang fokus pada perbaikan proses belajar mengajar matematika di SD/MI.',
    url: 'https://www.gernastastaka.org/',
    image: '/images/gnn/mitra/1 - Gernastastaka.jpg',
  },
  {
    fullDescription:
      'Program INOVASI (Inovasi untuk Anak Sekolah Indonesia) merupakan kemitraan antara pemerintah Australia dan Indonesia yang berfokus pada peningkatan kualitas pendidikan dasar, termasuk dalam bidang numerasi. Fase 1 program dimulai 2016-2020, fase 2 mulai 2020-2023, dan mulai 2024 ini masuk fase 3 sampai dengan 2027.',
    fullName: 'Inovasi untuk Anak Sekolah Indonesia',
    name: 'INOVASI',
    shortDescription:
      'Kemitraan Australia-Indonesia yang fokus pada peningkatan kualitas pendidikan dasar, termasuk numerasi.',
    url: 'https://www.inovasi.or.id/id/',
    image: '/images/gnn/mitra/2 - INOVASI.png',
  },
  {
    fullDescription:
      'KPM (Klinik Pendidikan MIPA) adalah lembaga pendidikan yang didirikan oleh Dr. Raden Ridwan Hasan Saputra, M.Si. di Bogor pada 16 April 2001. Awalnya KPM bergerak di bidang bimbingan belajar Matematika dan IPA, lalu lebih memfokuskan diri pada pembelajaran Matematika Nalaria Realistik (MNR). KPM menggunakan sistem unik yaitu Sistem Metode Seikhlasnya (SMS) dalam menjalankan program pendidikan. KPM juga menaruh perhatian pada pendidikan karakter, baik untuk siswa, guru, kepala sekolah, maupun masyarakat luas. Materi pendidikan karakter disusun langsung oleh Dr. Raden Ridwan Hasan Saputra, M.Si., penulis buku Cara Berpikir Suprarasional, Karakter Suprarasional, dan Manusia Suprarasional.',
    fullName: 'Klinik Pendidikan MIPA (KPM)',
    name: 'KPM (Klinik Pendidikan MIPA)',
    shortDescription:
      'Lembaga pendidikan yang fokus pada pembelajaran Matematika Nalaria Realistik (MNR) dan pendidikan karakter.',
    url: 'https://read1kpmseikhlasnya.com/',
    image: '/images/gnn/mitra/3 - KPM.png',
  },
  {
    fullDescription:
      'Gasing Academy adalah lembaga yang bekerja sama dengan pemerintah daerah (pemda) untuk meningkatkan kemampuan numerasi di kabupaten/kota. Saat ini, lebih dari 110 kabupaten/kota telah berpartisipasi dalam pelatihan ini. Pelatihan berlangsung selama 2 minggu, dan peserta tidak hanya dilatih untuk meningkatkan kemampuan dalam penjumlahan, perkalian, pengurangan, dan pembagian, tetapi juga untuk mengembangkan keterampilan 8C (Character, Creativity, Critical Thinking, Communication, Collaboration, Computational Logic, Compassion, dan Culture). Lebih dari 10.000 guru dan 15.000 peserta didik telah mengikuti pelatihan ini. Hasil yang terlihat adalah perubahan dalam cara mengajar guru, yang kini lebih mudah dipahami, efektif, inklusif, menyenangkan, dan mengajar dengan hati. Hal ini membuat peserta didik merasa lebih bahagia saat belajar. Video tentang pelatihan GASING di kabupaten dapat dilihat di www.youtube.com/@gasingacademy.',
    fullName: 'GASING Academy',
    name: 'GASING Academy',
    shortDescription:
      'Lembaga yang bekerja sama dengan pemda untuk meningkatkan kemampuan numerasi di kabupaten/kota.',
    url: 'https://gasingacademy.org/',
    image: '/images/gnn/mitra/4 - GasingAcademy.jpg',
  },
  {
    fullDescription:
      'Tanoto Foundation adalah organisasi filantropi independen yang didirikan oleh Bapak Sukanto Tanoto dan Ibu Tinah Bingei Tanoto. Kami percaya bahwa pendidikan berkualitas adalah kunci untuk mempercepat terciptanya kesetaraan kesempatan dan meningkatkan kualitas hidup. Dalam konteks pendidikan di Indonesia, Tanoto Foundation fokus pada pengurangan stunting, pendidikan anak usia dini, peningkatan literasi dan numerasi di pendidikan dasar, pengembangan kepemimpinan, serta pemberian beasiswa. Dalam upaya mendukung Gerakan Numerasi Nasional, Tanoto Foundation telah melaksanakan berbagai program yang berfokus pada peningkatan numerasi. Salah satu program utama kami adalah Program PINTAR (Pengembangan Inovasi untuk Kualitas Pembelajaran), yang mulai diimplementasikan sejak 2018. Program ini bertujuan untuk meningkatkan kualitas pembelajaran numerasi di jenjang pendidikan dasar melalui pelatihan guru, pengembangan modul pembelajaran, dan pemberdayaan komunitas pendidikan.',
    fullName: 'Tanoto Foundation',
    name: 'Tanoto Foundation',
    shortDescription:
      'Organisasi filantropi yang fokus pada peningkatan literasi dan numerasi di pendidikan dasar.',
    url: 'https://www.tanotofoundation.org/id/',
    image: '/images/gnn/mitra/5 - TanotoFoundation.jpg',
  },
  {
    fullDescription:
      "Yayasan Pembina Matematika dan IPA (YPMIPA) adalah sebuah yayasan non-profit yang berdiri tahun 2015, dengan visi 'Generasi Penerus: Realistik, Kreatif, Aspiratif dan Inovatif.' Dalam mewujudkan visi tersebut, kami memiliki 3 misi utama, pertama meningkatkan kemampuan dalam hal berkomunikasi baik secara lisan maupun non lisan, kedua meningkatkan kemampuan dalam mencari solusi untuk permasalahan masalah global, dan yang terakhir menciptakan generasi penerus yang berkarakter. Ketiga misi ini dalam rangka mendorong generasi penerus untuk pembangunan berkelanjutan dan pertumbuhan ekonomi Indonesia. Kegiatan yang kami lakukan adalah melakukan peningkatan kapasitas, pelatihan dan pendampingan.",
    fullName: 'Yayasan Pembina Matematika dan Ilmu Pengetahuan Alam',
    name: 'YPMIPA',
    shortDescription:
      'Yayasan non-profit yang fokus pada peningkatan kapasitas dan pendampingan pendidikan MIPA.',
    url: 'https://ypmipa.org/',
    image: '/images/gnn/mitra/6 - YPMIPA.png',
  },
  {
    fullDescription:
      'Komunitas Penggerak Numerasi Indonesia (KPNI) adalah Komunitas Belajar yang didirikan pada bulan Juni Tahun 2022 oleh Alumni Awardee Beasiswa Microcredential Numerasi (Numeracy Professional Learning Program) Angkatan Pertama Tahun 2022. Inisiasi pendidiran KPNI ini merupakan upaya untuk memasyarakatkan numerasi di Indonesia. KPNI fokus pada pengembangan kompetensi numerasi melalui kegiatan komunitas belajar berupa kegiatan pengembangan kompetensi dan berbagi praktik baik numerasi khususnya pada bidang pendidikan dan pembelajaran di segala jenjang.',
    fullName: 'Komunitas Penggerak Numerasi Indonesia',
    name: 'KPNI',
    shortDescription:
      'Komunitas belajar yang fokus pada pengembangan kompetensi numerasi di berbagai jenjang pendidikan.',
    image: '/images/gnn/mitra/7 - KPNI.jpg',
  },
]

export const PENGUATAN_KETERAMPILAN_CARDS = [
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://sindara.gurudikdas.kemendikdasmen.go.id/gerai-numerasi',
    },
    icon: (
      <IconBg className="bg-blue-10">
        <Icon className="!text-blue-60">account_balance</Icon>
      </IconBg>
    ),
    text: 'Pengembangan keterampilan Numerasi masyarakat dapat melalui pendekatan 3 pilar yakni Mind Set (Pola Pikir Bernumerasi), Skill Set (Keterampilan Bernumerasi) dan Tool Set (Alat Bernumerasi).',
    title: '3 (Tiga) Pilar Pengembangan Keterampilan Numerasi',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://www.youtube.com/watch?v=suD03-SIFDQ&list=PLiOcneNuJZNaMr3Ib7v_8VubAFLm2YJBm',
    },
    icon: (
      <IconBg className="bg-green-10">
        <Icon className="!text-green-60">mode_comment</Icon>
      </IconBg>
    ),
    text: 'Ngobrol santai dan percakapan rutin dengan durasi singkat (maks 10 menit) yang membangun kemampuan numerasi yang dapat dilakukan di mana saja dan kapan saja.',
    title: 'Bincang Numerasi',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://docs.google.com/spreadsheets/d/1bwWE6M0zWKPNJH5Fh7OyPfjNJlVEqAxrhub7CLzVmEs/view',
    },
    icon: (
      <IconBg className="bg-purple-10">
        <Icon className="!text-purple-60">forest</Icon>
      </IconBg>
    ),
    text: 'Lokasi tempat terjadinya Bincang Numerasi yang mendukung 3 pilar GNN yakni Mind Set, Tool Set dan atau Skill Set.',
    title: 'Taman Numerasi',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: '/gnn/sumber-belajar',
    },
    icon: (
      <IconBg className="bg-orange-10">
        <Icon className="!text-orange-600">lists</Icon>
      </IconBg>
    ),
    text: 'Sumber rujukan materi numerasi bagi siswa, guru dan tenaga kependidikan serta orang tua maupun masyarakat umum.',
    title: 'Gerai Numerasi',
  },
]

export const STRATEGI_GNN_CARDS = [
  {
    button: {
      text: 'Gerai Numerasi',
      url: 'https://sindara.gurudikdas.kemendikdasmen.go.id/gerai-numerasi',
    },
    icon: (
      <IconBg className="bg-blue-10">
        <Icon className="!text-blue-60">school</Icon>
      </IconBg>
    ),
    text: 'Peningkatan Kompetensi Guru dalam implementasi pembelajaran Mendalam di mata pelajaran MATEMATIKA melalui bimbingan Teknis dengan alur pembelajaran GEMBIRA, yang merupakan akronim dari lima tahapan utama: Gali dan Eksplorasi, Muat konten, Buat aktivitas, Ikuti pemikiran siswa, Rasakan dan Apresiasi.',
    title: 'Sekolah',
  },
  {
    button: {
      text: 'Buku Saku GNN Keluarga',
      url: 'https://drive.google.com/file/d/168lSK7IB3OknZSGrmlBtXio4Jk6yeA1l/view',
    },
    icon: (
      <IconBg className="bg-green-10">
        <Icon className="!text-green-60">home</Icon>
      </IconBg>
    ),
    text: 'Membekali proses pendampingan anak dalam mengembangkan kemampuan berpikir logis dan matematis melalui aktivitas sehari-hari di rumah.',
    title: 'Keluarga',
  },
  {
    button: {
      text: 'Panduan Operasional Taman Numerasi',
      url: 'https://drive.google.com/file/d/1qdaSegSDXo6Eu66fZ3M0r0SyafY2nNXg/view',
    },
    icon: (
      <IconBg className="bg-purple-10">
        <Icon className="!text-purple-60">group</Icon>
      </IconBg>
    ),
    text: 'Menanamkan fondasi numerasi secara menyenangkan dan bermakna dengan mengoptimalkan ruang terbuka/ tertutup untuk Taman Numerasi.',
    title: 'Masyarakat',
  },
  {
    button: {
      text: 'Ruang GTK',
      url: '/',
    },
    icon: (
      <IconBg className="bg-orange-10">
        <Icon className="!text-orange-600">tv</Icon>
      </IconBg>
    ),
    text: 'Pemanfaatan media komunikasi untuk membangun kesadaran, partisipasi dan kolaborasi seluruh pemangku kepentingan melalui pesan inklusif, mudah dipahami, konsisten di berbagai saluran komunikasi.',
    title: 'Media',
  },
]

export const TESTIMONY_CARDS = [
  {
    testimony:
      'Manfaatkan kelas-kelas menjadi Taman Numerasi agar anak menjadi lebih berkualitas dalam melakukan aktifitas pembelajaran yang dekat dengan dunia nyata.',
    name: 'Nartianis',
    schoolName: 'Ketua IGTKI Provinsi Riau',
  },
  {
    testimony:
      'Gerakan Numerasi Nasional sebagai langkah awal melatih anak sejak dini untuk belajar Matematika, agar tidak berkesan menakutkan tapi seru dan bermanfaat dalam kehidupan Sehari-hari.',
    name: 'Hj. Henny Sasmita Wahid',
    schoolName: 'Bunda PAUD Provinsi Riau',
  },
  {
    testimony:
      'Dalam era yang semakin maju ini, kemampuan berhitung, berpikir logis, dan memahami data menjadi sangat penting. Melalui GNN, kita berupaya menanamkan budaya numerasi sejak dini, dari keluarga, sekolah, hingga masyarakat luas.',
    name: 'Dadang A. Sapardan, M.Pd., Kp.',
    schoolName: 'Camat Cikalongwetan Barat',
  },
  {
    testimony:
      'Saya percaya, dengan kerjasama seluruh elemen bangsa, GNN dapat meningkatkan kualitas sumber daya manusia Indonesia yang cerdas dan siap menghadapi tantangan masa depan.',
    name: 'Dr. H. Dony Ahmad Munir, S.T.M.M.',
    schoolName: 'Bupati Sumedang',
  },
  {
    testimony:
      'Taman Numerasi yang ada di BGTK Papua memiliki ragam pilihan permainan yang mengasah keingintahuan anak dalam melatih logika dan berfikir kritis. Sehingga membuat anak betah dan tidak ingin pulang.',
    name: 'Yuni Israhayu',
    schoolName: 'TK Ananda Kids Papua',
  },
  {
    testimony:
      'Taman Numerasi di BGTK Papua membuat belajar angka menjadi lebih hidup dan menyenangkan. Guru sangat terbantu dan dapat bereksplorasi pembelajaran karena anak-anak aktif.',
    name: 'Naffah Indah Mujianto',
    schoolName: 'TK Ananda Kids Papua',
  },
  {
    testimony:
      'Saya sangat bersyukur bahwa melalui Gerakan Numerasi Nasional salah satunya menghadirkan Taman Numerasi. Karena bukan hanya menjadi pengingat kita bahwa Numerasi juga bagian dari prioritas seperti halnya Literasi, tetapi Taman Numerasi ini juga bisa menjadi wadah yang ramah untuk mendukung peningkatan kemampuan numerasi guru, anak-anak juga masyarakat.',
    name: 'Nuvis Melodiana',
    schoolName: 'Guru SMP Negeri 4 Krui Pesisir Barat, Lampung',
  },
]

export const PANDUAN_GNN_CARDS = [
  {
    title: 'Pedoman Gerakan Numerasi Nasional',
    text: 'Pedoman lengkap implementasi Gerakan Numerasi Nasional yang mencakup strategi, kegiatan, dan pelaksanaan program di berbagai lingkungan.',
    url: 'https://sindara.gurudikdas.kemendikdasmen.go.id/gerai-numerasi?tab=unduhan',
    btnText: 'Unduh Pedoman',
  },
  {
    title: 'Buku Saku Bincang Numerasi di Sekolah',
    text: 'Panduan praktis untuk guru dan tenaga kependidikan dalam menerapkan bincang numerasi di lingkungan sekolah secara efektif dan menyenangkan.',
    url: 'https://drive.google.com/file/d/1XtFvcQZ98OAImQ_giKcCbU2vihBBPWsY/view',
  },
  {
    title: 'Panduan Saku Bincang Numerasi Keluarga',
    text: 'Panduan untuk orang tua dan keluarga dalam mengembangkan kemampuan numerasi anak melalui aktivitas sehari-hari di rumah.',
    url: 'https://drive.google.com/file/d/168lSK7IB3OknZSGrmlBtXio4Jk6yeA1l/view',
  },
  {
    title: 'Buku Saku Numerasi Masyarakat',
    text: 'Panduan numerasi untuk masyarakat umum yang membantu memahami pentingnya numerasi dalam kehidupan bermasyarakat dan bernegara.',
    url: 'https://drive.google.com/file/d/1Mfn5Q8yb3rBzGBFOFZO-UCI_Ym8Kh_z_/view',
  },
  {
    title: 'Panduan Operasional Taman Numerasi',
    text: 'Panduan lengkap untuk perencanaan, pembangunan, dan operasional taman numerasi sebagai ruang belajar yang menyenangkan dan interaktif.',
    url: 'https://drive.google.com/file/d/1qdaSegSDXo6Eu66fZ3M0r0SyafY2nNXg/view',
  },
]

export const KEGIATAN_GNN_CARDS = [
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://sindara.gurudikdas.kemendikdasmen.go.id/gerai-numerasi?tab=praktik-baik',
    },
    icon: (
      <IconBg size="sm" className="bg-green-10">
        <Icon className="!text-green-60">lightbulb</Icon>
      </IconBg>
    ),
    text: 'Kumpulan praktik baik implementasi numerasi dari berbagai daerah di Indonesia yang dapat menjadi inspirasi dan referensi.',
    title: 'Praktik Baik',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://www.youtube.com/watch?v=suD03-SIFDQ&list=PLiOcneNuJZNaMr3Ib7v_8VubAFLm2YJBm',
    },
    icon: (
      <IconBg size="sm" className="bg-green-10">
        <Icon className="!text-green-60">podcasts</Icon>
      </IconBg>
    ),
    text: 'Koleksi podcast dan video edukasi tentang numerasi yang dapat diakses kapan saja untuk pembelajaran mandiri.',
    title: 'Siniar Bincang Numerasi',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: 'https://docs.google.com/spreadsheets/d/1bwWE6M0zWKPNJH5Fh7OyPfjNJlVEqAxrhub7CLzVmEs/view',
    },
    icon: (
      <IconBg size="sm" className="bg-green-10">
        <Icon className="!text-green-60">pin_drop</Icon>
      </IconBg>
    ),
    text: 'Daftar lengkap lokasi taman numerasi di seluruh Indonesia yang dapat dikunjungi untuk pembelajaran langsung.',
    title: 'Info Lokasi Taman Numerasi',
  },
  {
    button: {
      text: 'Selengkapnya',
      url: '/komunitas/webinar',
    },
    icon: (
      <IconBg size="sm" className="bg-green-10">
        <Icon className="!text-green-60">co_present</Icon>
      </IconBg>
    ),
    text: 'Berbagai webinar untuk berbagi inspirasi dan keterampilan untuk implementasi Gerakan Numerasi Nasional di lingkungan satuan pendidikan.',
    title: 'Webinar GNN',
  },
]

export const ARTICLE_CARDS = [
  {
    title: 'Surprise Box Rahasia untuk Belajar Penyajian Data',
    url: 'https://guru.kemdikbud.go.id/cerita-praktik/4Lw95bq0Mq',
  },
  {
    title: 'Meningkatkan Kemampuan Numerasi dengan Coding',
    url: 'https://guru.kemdikbud.go.id/cerita-praktik/GJ86jNG6Ev',
  },
  {
    title: 'Asyiknya Belajar Numerasi dengan Mencermati Teks Berita',
    url: 'https://guru.kemdikbud.go.id/cerita-praktik/kGn0zaE9eN',
  },
  {
    title: 'Permainan Ular Tangga untuk Konsep Operasi Hitung Bilangan Bulat',
    url: 'https://guru.kemdikbud.go.id/cerita-praktik/GJ86jJw6Ev',
  },
]

export const NEWS_CARDS = [
  {
    title:
      'Mendikdasmen Ingin Anak-anak Lebih Cinta Matematika, Perkuat Lewat Permainan',
    url: 'https://share.google/Q4qtxYM7Vs6E1ESxh ',
    source: 'KumparanNews',
  },
  {
    title:
      'Komisi X Ajak Anak Indonesia untuk Tidak Takut Matematika Jika Ingin Sukses',
    url: 'https://share.google/0Y8TMH9ufxFjXlI2F',
    source: 'DetikEdu',
  },
  {
    title:
      'Mendikdasmen Sorot Banyak Anak Indonesia Tidak Bisa Baca Jam Analog',
    url: 'https://share.google/T64JGdmDWRQvMN7rT',
    source: 'DetikEdu',
  },
  {
    title: "Matematika Harus 'Fun' Agar Anak-anak Suka - Gaya Hidup",
    url: 'https://share.google/w6DXzemDyY34KRQFr',
    source: 'Bloomberg Technoz',
  },
  {
    title:
      'Kemendikdasmen Bangun Taman Numerasi di 140 Sekolah, Fokus Dongkrak PISA',
    url: 'https://share.google/eePRFJTI7WA1y9hn4',
    source: 'Inilah',
  },
  {
    title: 'Kemendikdasmen Luncurkan Gerakan Numerasi Nasional',
    url: 'https://jatim.antaranews.com/berita/962657/kemendikdasmen-luncurkan-gerakan-numerasi-nasional',
    source: 'AntaraJatim',
  },
]
